if (!customElements.get('how-container')) {
  class HowContainer extends HTMLElement {
    constructor() {
      super();

      /** @type {HTMLElement} */
      // @ts-expect-error
      this.boxesContainer = this.querySelector('.how__boxes');

      /** @type {NodeListOf<HTMLElement>} */
      this.boxes = this.boxesContainer.querySelectorAll('.how__box');

      /** @type {HTMLElement} */
      // @ts-expect-error
      this.prevButton = this.querySelector('[data-prev]');

      /** @type {HTMLElement} */
      // @ts-expect-error
      this.nextButton = this.querySelector('[data-next]');

      /** @type {HTMLElement} */
      // @ts-expect-error
      this.currentNumber = this.querySelector('[data-current]');

      this.prevButton.addEventListener('click', this.onPrev.bind(this));
      this.nextButton.addEventListener('click', this.onNext.bind(this));
      this.boxesContainer.addEventListener(
        'scrollend',
        this.onScrollEnd.bind(this),
      );
    }

    onScrollEnd() {
      const firstSlide = this.boxes[0];
      const slideWidth = firstSlide.clientWidth;
      const newIndex = Math.round(this.boxesContainer.scrollLeft / slideWidth);
      this.setIndex(newIndex);
    }

    onPrev() {
      if (this.prevButton.classList.contains('is-disabled')) {
        return;
      }
      const current = Number(this.currentNumber.textContent) - 1;
      const prev = current === 0 ? this.boxes.length - 1 : current - 1;
      this.setIndex(prev);
    }

    onNext() {
      if (this.nextButton.classList.contains('is-disabled')) {
        return;
      }

      const current = Number(this.currentNumber.textContent) - 1;
      const next = current + 1 === this.boxes.length ? 0 : current + 1;
      this.setIndex(next);
    }

    /**
     * @param {number} index
     */
    setIndex(index) {
      const num = this.boxes.length;

      const hasPrev = index > 0;
      const hasNext = index < num - 1;

      this.prevButton.classList.toggle('is-disabled', !hasPrev);
      this.nextButton.classList.toggle('is-disabled', !hasNext);

      this.currentNumber.textContent = (index + 1).toString();
      const boxWidth = this.boxes[index].getBoundingClientRect().width;
      const newScrollLeft = boxWidth * index;

      this.boxesContainer.scrollLeft = newScrollLeft;
    }
  }

  customElements.define('how-container', HowContainer);
}
